
import React, { Component } from 'react';
import './Solicitud.css';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft, FaPlus, FaSignInAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { getSolicitudCompra, clearErrors } from '../../../redux/actions/dataasistencialactions';
import AddItemSolicitud from './AddItemSolicitud';
import EnviarSolicitud from './EnviarSolicitud';
//import PublicarCotizacion from './PublicarCotizacion';


export class Solicitud extends Component {
    componentDidMount() {
        this.props.getSolicitudCompra(this.props.match.params.solicitudid);
    }

    render() {

        const { solicitud, loadingdataasistencial } = this.props.dataAsistencial;
        dayjs.extend(relativeTime);

        let cargarSolicitud = !loadingdataasistencial && solicitud && solicitud.credentials ? (
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h5" color="primary" gutterBottom>
                                {solicitud.credentials.titulo}
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                        </Grid>

                        {/* Solicitud Info section */}
                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="subtitle2" color="textSecondary">Estado:</Typography>
                            <Typography variant="body1">{solicitud.credentials.estado}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="subtitle2" color="textSecondary">Fecha de Solicitud:</Typography>
                            <Typography variant="body1">{dayjs(solicitud.credentials.datecreation).fromNow()}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="subtitle2" color="textSecondary">Area:</Typography>
                            <Typography variant="body1">{solicitud.credentials.area}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="subtitle2" color="textSecondary">Servicio:</Typography>
                            <Typography variant="body1">{solicitud.credentials.servicio}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="subtitle2" color="textSecondary">Categoria:</Typography>
                            <Typography variant="body1">{solicitud.credentials.categoria}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="subtitle2" color="textSecondary">Tipo Cotizacion:</Typography>
                            <Typography variant="body1">{solicitud.credentials.tipocotizacion}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ my: 1 }} />
                        </Grid>

                        {/* Responsable Info section */}
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="subtitle2" color="textSecondary">Nombre Responsable:</Typography>
                            <Typography variant="body1">{solicitud.credentials.nombreresponsable}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="subtitle2" color="textSecondary">Cargo Responsable:</Typography>
                            <Typography variant="body1">{solicitud.credentials.cargoresponsable}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="subtitle2" color="textSecondary">Teléfono Responsable:</Typography>
                            <Typography variant="body1">{solicitud.credentials.cargoresponsable}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="subtitle2" color="textSecondary">Email Responsable:</Typography>
                            <Typography variant="body1">{solicitud.credentials.emailresponsable}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ my: 1 }} />
                        </Grid>

                        {/* Observaciones Info section */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" color="textSecondary">Observaciones:</Typography>
                            <Typography variant="body1">{solicitud.credentials.observaciones}</Typography>
                        </Grid>

                    </Grid>
                </CardContent>
            </Card>
        ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress size={50} color="primary" />
            </Box>
        );


        let mapeoitems = !loadingdataasistencial && solicitud && solicitud.credentials ?
            (solicitud.credentials.items !== undefined && solicitud.credentials.items.length > 0 ? (
                solicitud.credentials.items.map((item) =>
                    <Card key={item.datecreation} sx={{ mb: 2, background: '#f9f9f9', borderLeft: '4px solid #1976d2' }}>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3}>
                                    <Typography variant="subtitle2" color="textSecondary">Nombre</Typography>
                                    <Typography variant="body1" fontWeight="bold">{item.nombre}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Typography variant="subtitle2" color="textSecondary">Marca</Typography>
                                    <Typography variant="body1">{item.marca}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Typography variant="subtitle2" color="textSecondary">Cantidad</Typography>
                                    <Typography variant="body1">{item.cantidad}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="subtitle2" color="textSecondary">Descripcion</Typography>
                                    <Typography variant="body1">{item.descripcion}</Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                )
            ) : (
                <Card sx={{ mb: 2 }}>
                    <CardContent sx={{ textAlign: 'center' }}>
                        <Typography variant="h6" color="textSecondary">Añade un Item para Empezar</Typography>
                    </CardContent>
                </Card>
            )) :
            (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                    <CircularProgress size={50} color="primary" />
                </Box>
            );



        return (
            <Box sx={{ flexGrow: 1, p: 2 }}>

                <Grid container spacing={2} alignItems="center" className="titulo_section" sx={{ mb: 2 }}>
                    <Grid item xs={12} md={9} className="titulo_clientes">
                        <h1 className="text-clientes" style={{ margin: 0 }}>Solicitud de Compra</h1>
                    </Grid>

                    <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
                        <Link to={`/dashboard/solicitudesasistencial/missolicitudessinenviar`} style={{ textDecoration: 'none' }}>
                            <MyButton tip="Volver">
                                <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
                            </MyButton>
                        </Link>
                    </Grid>
                    <Grid item xs={12}>
                        <hr className="clientes_separator" style={{ margin: 0 }} />
                    </Grid>
                </Grid>

                <Box sx={{ mb: 4 }}>
                    {cargarSolicitud}
                </Box>

                <Grid container spacing={2} alignItems="center" className="titulo_section" sx={{ mb: 2 }}>
                    <Grid item xs={12} md={9} className="titulo_clientes">
                        <h1 className="text-clientes" style={{ margin: 0 }}>Añade un Item</h1>
                    </Grid>

                    <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
                        <AddItemSolicitud solicitudId={this.props.match.params.solicitudid}></AddItemSolicitud>
                    </Grid>
                    <Grid item xs={12}>
                        <hr className="clientes_separator" style={{ margin: 0 }} />
                    </Grid>
                </Grid>

                <Box sx={{ mb: 4 }}>
                    {mapeoitems}
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                        <EnviarSolicitud solicitudId={this.props.match.params.solicitudid} history={this.props.history}></EnviarSolicitud>
                    </Box>
                </Box>

            </Box>
        )
    }
}

Solicitud.propTypes = {

    getSolicitudCompra: PropTypes.func.isRequired,
    dataAsistencial: PropTypes.object.isRequired,
    clearErrors: PropTypes.func.isRequired,
    UI: PropTypes.object.isRequired,

};

const mapActionsToProps = { getSolicitudCompra, clearErrors };

const mapStateToProps = (state) => ({
    dataAsistencial: state.dataAsistencial,
    UI: state.UI
})



export default connect(mapStateToProps, mapActionsToProps)(Solicitud);
